/**
 * Prevents double-clicking form buttons for 250ms.
 * Do not slow this too much, as it will significantly slow down fast scanning.
 */
(function _FormSlower() {
  function _blockButton(this: TSFixMe) {
    const button = this;
    if (!button.disabled) {
      setTimeout(function _doBlockButton() {
        button.disabled = true;
        setTimeout(function _undoBlockButton() {
          button.disabled = false;
        }, 250);
      }, 10);
    }
  }

  $(document).on(
    'click',
    'form button:not(.cr-button):not(.cr-button--unstyled), form input[type=submit]',
    _blockButton
  );
})();
